import styled from '@emotion/styled'

import { Space } from '../../../components/core-v2'

export const StyledContainer = styled(Space)`
  height: 40px;
`
